interface HideWrapperProps {
  hide: boolean;
  children: React.ReactNode;
}

function HideWrapper(props: HideWrapperProps) {
  if (props.hide) return null;
  return <>{props.children}</>;
}

export { HideWrapper };
